import React from 'react';
import { Link } from 'react-router-dom';
import { l10n } from '../i18n/Localization';

const DatumCard = (props) => {
    const { name, value, url } = props;

    return (
        <div className="card bg-dark text-white text-center border-light h-100">
            <div className="card-body">
                <h5 className="card-title">{name}</h5>
                <h1 className="display-3">{value}</h1>
            </div>
            <div className="card-footer">
                <Link className="btn btn-primary float-right" to={url}><i className="bi-zoom-in mr-2"></i>{l10n.action.view}</Link>
            </div>
        </div>
    );
};

export default DatumCard;
